import { optOutTracking as optOutTrackingSmartlink } from '@hubxco/hubx-smartlink';
import { setAnalyticsCollectionEnabled } from 'firebase/analytics';

import { analytics } from '@/providers/firebase';

export function optOutTracking(): void {
  setAnalyticsCollectionEnabled(analytics, false);
  optOutTrackingSmartlink();
}
